(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-product')) return;

  var bumpedAt = 0;

  function getWidget() {
    return document.querySelector('#judgeme_product_reviews, .jm-review-widget, .jdgm-rev-widg');
  }

  function bumpReviewCount() {
    var now = Date.now();
    if (now - bumpedAt < 4000) return;
    var widget = getWidget();
    if (!widget) return;

    var updated = false;
    var walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!text) continue;

      var match = text.match(/^(\s*)(\d+)(\s+)(reviews?)(\s*)$/i);
      if (!match) continue;

      var count = parseInt(match[2], 10) + 1;
      var label = count === 1 ? 'review' : 'reviews';
      if (/Reviews?/i.test(match[4]) && match[4][0] === match[4][0].toUpperCase()) {
        label = count === 1 ? 'Review' : 'Reviews';
      }

      node.nodeValue = match[1] + count + match[3] + label + match[5];
      updated = true;
      break;
    }

    if (updated) bumpedAt = now;
  }

  function looksLikeSuccess(el) {
    if (!el || el.nodeType !== 1) return false;
    var text = (el.textContent || '').toLowerCase();
    var cls = (el.className && typeof el.className === 'string' ? el.className : '').toLowerCase();

    if (cls.indexOf('success') !== -1) return true;
    if (
      (text.indexOf('thank') !== -1 || text.indexOf('terima kasih') !== -1) &&
      (text.indexOf('review') !== -1 || text.indexOf('submitted') !== -1 || text.indexOf('dikirim') !== -1)
    ) {
      return true;
    }
    return false;
  }

  function onReviewSuccess() {
    bumpReviewCount();

    try {
      if (window.jdgm && typeof window.jdgm.reloadWidgets === 'function') {
        window.jdgm.reloadWidgets();
      } else if (typeof window.jdgm_preloader === 'function') {
        window.jdgm_preloader();
      }
    } catch (err) {
      /* ignore */
    }
  }

  ['jdgm.doneDone', 'jdgm.reviewSubmitted', 'jdgm:reviewSubmitted', 'judgeme:reviewSubmitted'].forEach(function (evt) {
    document.addEventListener(evt, onReviewSuccess);
    window.addEventListener(evt, onReviewSuccess);
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (looksLikeSuccess(node) || (node.querySelector && node.querySelector('[class*="success"], [class*="Success"]'))) {
          onReviewSuccess();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest) return;
      if (!form.closest('#judgeme_product_reviews, .jm-review-widget, .jdgm-write-rev-form, [class*="write-review"], [class*="WriteReview"]')) {
        return;
      }
      setTimeout(onReviewSuccess, 1500);
    },
    true
  );
})();
